export default __webpack_public_path__ + "images/hub-hero-min-1_af423e13c0f9130f8b34d72536625326.jpg";